import { render } from "./notificacionesreservas.vue?vue&type=template&id=b707ed62&scoped=true"
import script from "./notificacionesreservas.vue?vue&type=script&lang=js"
export * from "./notificacionesreservas.vue?vue&type=script&lang=js"

import "./notificacionesreservas.vue?vue&type=style&index=0&id=b707ed62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b707ed62"]])

export default __exports__